import * as types from "../actions/actionTypes";
import createEntityReducer from "./createEntityReducer";

export default createEntityReducer({
  entity: "order",
  listKey: "orders",
  itemKey: "order",
  getAll: types.GET_ALL_ORDERS,
  getAllResponse: types.GET_ALL_ORDERS_RESPONSE,
  getByIdResponse: types.GET_ORDER_BY_ID_RESPONSE,
});
